<template>
  <div>
    <b-container>
      <b-row>
        <b-col sm="3">
          <Filters>
            <div class="search-box">
              <p class="h4 text-center">التاجز</p>
              <multiselect
                placeholder="اختر نوع المطعم"
                :multiple="true"
                v-model="selectedTags"
                :options="tags">
              </multiselect>
            </div>
          </Filters>
        </b-col>

        <b-col sm="9">
          <b-row>
            <b-col cols="6" sm="12"  v-for="s in 3" :key="s">
              <SingleRestaurant/>
            </b-col>
          </b-row>
          <div class="pagination">
            <b-pagination
              v-model="currentPage"
              :total-rows="5"
              :per-page="1"
              first-number
              last-number
            ></b-pagination>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script type="text/javascript">
  import Multiselect      from 'vue-multiselect'
  import Filters          from "../global/Filters"
  import SingleRestaurant from './SingleRestaurant'




  export default {
    name:'Restaurnts',
    components: {
      Filters,
      Multiselect,
      SingleRestaurant,
    },
    data() {
      return {
        priceRange:[100,400],
        currentPage:null,
        selectedTags:null,
        tags:["اسماك", "برجر", "مشويات", "وجبات سريعه"],
      }
    }
  }
</script>
